import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle max-w-md sm:w-full sm:p-4" }
const _hoisted_4 = { class: "mt-2 text-left sm:mt-5" }
const _hoisted_5 = { class: "flex justify-between" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Withdraw Request ")
const _hoisted_7 = { class: "mt-2 pb-2 text-left" }
const _hoisted_8 = { class: "text-left p-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("b", null, "Username", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("b", null, "Amount", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("b", null, "Approve Message", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_13 = { class: "row text-center text-white" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "Approve", -1)
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, "Reject", -1)

import { computed, ref } from "vue";
import {
  Dialog,
  DialogTitle,
  DialogOverlay,
  TransitionRoot,
  TransitionChild,
} from "@headlessui/vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewManualWithdrawDialog',
  props: {
  show: Boolean,
  loading: Boolean,
  form: Object as () => any,
},
  emits: [
  "submit",
  "update:show",
  "update:form",
  "update:loading",
  "approve",
  "reject",
],
  setup(__props, { emit }) {

const props = __props

const store = useStore();
const showSync = computed({
  get: () => props.show,
  set: (value) => emit("update:show", value),
});
const formSync = computed({
  get: () => props.form,
  set: (value) => emit("update:form", value),
});
const loadingSync = computed({
  get: () => props.loading,
  set: (value) => emit("update:loading", value),
});




const closeDialog = () => {
  formSync.value = {};
  showSync.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: _unref(showSync)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        static: "",
        class: "fixed z-10 inset-0 overflow-y-auto",
        onClose: _cache[3] || (_cache[3] = ($event: any) => (showSync.value = false)),
        open: _unref(showSync)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
              ]),
              _: 1
            }),
            _hoisted_2,
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
              "enter-to": "opacity-100 translate-y-0 sm:scale-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100 translate-y-0 sm:scale-100",
              "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_Transition, {
                    "leave-active-class": "transition duration-100 ease-in",
                    "leave-from-class": "opacity-100",
                    "leave-to-class": "opacity-0"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_unref(DialogTitle), {
                              as: "h3",
                              class: "text-lg leading-6 font-medium text-gray-900"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_6
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("p", null, [
                                _hoisted_9,
                                _createTextVNode(": " + _toDisplayString(__props.form.user_name || __props.form.user_phone || __props.form.user_id), 1)
                              ]),
                              _createElementVNode("p", null, [
                                _hoisted_10,
                                _createTextVNode(": " + _toDisplayString(Number(__props.form.amount/100).toFixed(2)), 1)
                              ]),
                              _createElementVNode("p", null, [
                                _hoisted_11,
                                _hoisted_12,
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  placeholder: "input approve message",
                                  class: "rounded my-3 w-full",
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.form.approveMsg) = $event))
                                }, null, 512), [
                                  [_vModelText, __props.form.approveMsg]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("button", {
                                onClick: closeDialog,
                                class: "rounded bg-gray-500 p-2 m-1"
                              }, " Cancel "),
                              (_unref(store).state.user.permissions.includes('USER.MANUAL_WITHDRAW_APPROVE'))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "rounded bg-blue-500 p-2 m-1",
                                    disabled: _unref(loadingSync),
                                    onClickOnce: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('approve','approve')))
                                  }, [
                                    (_unref(loadingSync))
                                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                          key: 0,
                                          class: "text-gray-500",
                                          icon: ['fas', 'circle-notch'],
                                          transform: "grow-6",
                                          spin: ""
                                        }))
                                      : _createCommentVNode("", true),
                                    _hoisted_15
                                  ], 40, _hoisted_14))
                                : _createCommentVNode("", true),
                              (_unref(store).state.user.permissions.includes('USER.MANUAL_WITHDRAW_APPROVE'))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    class: "rounded bg-red-500 p-2 m-1",
                                    disabled: _unref(loadingSync),
                                    onClickOnce: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('reject','reject')))
                                  }, [
                                    (_unref(loadingSync))
                                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                          key: 0,
                                          class: "text-gray-500",
                                          icon: ['fas', 'circle-notch'],
                                          transform: "grow-6",
                                          spin: ""
                                        }))
                                      : _createCommentVNode("", true),
                                    _hoisted_17
                                  ], 40, _hoisted_16))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})